import { Dialog, DialogActions, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { DialogContentCustom } from '../../components/confirmation-area/ConfirmationArea.styled';
import { ButtonCustom } from '../customer-portal/signin/CustomerPortalSignIn.styles';
import { IProductStockBalance } from '../../interfaces/IProductStockBalance';

interface IProps {
  title?: string;
  products: IProductStockBalance[];
  dialogOpen: boolean;
  deny: () => void;
}

const ProductStockbalancedDialog = ({ dialogOpen, deny, products }: IProps) => {
  return (
    <Dialog open={dialogOpen}>
      <DialogContentCustom sx={{ width: 'auto' }}>
        <h1>Quantidade de produto por filial</h1>
        {products.length > 0 ? (
          <>
            <h1>
              {products[0].product?.sku} - {products[0].product?.description}
            </h1>
            <Table>
              <TableRow
                sx={{
                  '&:last-child td, &:last-child th': {
                    borderBottom: 1,
                    borderColor: '#E5E5E5',
                  },
                }}
              >
                <TableCell>Filial</TableCell>
                <TableCell>Depósito</TableCell>
                <TableCell>Quantidade</TableCell>
              </TableRow>
              <TableBody>
                {products.map(product => {
                  return (
                    <TableRow key={product.id}>
                      <TableCell size="small">
                        {product.branchOffice?.code} - {product.branchOffice?.name}
                      </TableCell>
                      <TableCell size="small">{product.storage}</TableCell>
                      <TableCell size="small">{product.quantity}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </>
        ) : (
          <p>Sem dados a exibir </p>
        )}
      </DialogContentCustom>
      <DialogActions>
        <ButtonCustom onClick={deny} color="error" size="small" sx={{ width: '50%' }}>
          Voltar
        </ButtonCustom>
      </DialogActions>
    </Dialog>
  );
};
export default ProductStockbalancedDialog;
